<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
Program: Excel Upload
Author: SDL
Description: Excel Upload Common Component
-->
<template>
  <button type="button" :class="btnClass" @click="excelDownload()">{{ $t(btnLabel) }}</button>
</template>
<script>
import axios from 'axios';
import SDLUtil from '@/utils/SDLUtil';

import "@grapecity/spread-sheets-vue";
import GC from "@grapecity/spread-sheets";
import "@grapecity/spread-sheets-io";
import "@grapecity/spread-sheets-charts";
import "@grapecity/spread-sheets-shapes";
import "@grapecity/spread-sheets-tablesheet";
import '@grapecity/spread-sheets-resources-ko';

import { saveAs } from 'file-saver';

GC.Spread.Common.CultureManager.culture("ko-kr");

export default {
  name: 'ExcelDownload',
  props: {
    btnLabel: {
      required: false,
      type: String,
      default: 'sdl.common.label.excelDownload',
    },
    btnClass: {
      type: String,
      default: 'btn btn-secondary',
    },
    excelName: {
      type: String,
      default: 'Export',
    },
    spread: {
      type: Object,
      default: () => {},
    },
    excelProp: {
      type: Object,
      default: () => {},
    },
    /*
    excelInfo: {
      required: true,
      type: Object,
      default: () => {},
    }, */
    // excelServiceFlag: {
    //   type: Boolean,
    //   required: false,
    //   default: false,
    // },
    /* beforeClick: {
      type: Function,
      default: () => true,
    }, */
  },
  data() {
    return {
      //saveFileType: "xls",
      saveOptions: {
          includeBindingSource: false,
          includeStyles: true,
          includeFormulas: true,
          saveAsView: false,
          rowHeadersAsFrozenColumns: false,
          columnHeadersAsFrozenRows: true,
          includeAutoMergedCells: false,
          includeCalcModelCache: false,
          includeUnusedNames: true,
          includeEmptyRegionCells: true,
          encoding: "UTF-8",
          rowDelimiter: "\r\n",
          columnDelimiter: ",",
          sheetIndex: 0,
          row: 0,
          column: 0,
          rowCount: 200,
          columnCount: 20,
      },
      // saveOptionsConfig: [
      //         { propName: "includeBindingSource", type: "boolean", default: false },
      //         { propName: "includeStyles", type: "boolean", default: true },
      //         { propName: "includeFormulas", type: "boolean", default: true },
      //         { propName: "saveAsView", type: "boolean", default: false },
      //         { propName: "rowHeadersAsFrozenColumns", type: "boolean", default: false },
      //         { propName: "columnHeadersAsFrozenRows", type: "boolean", default: false },
      //         { propName: "includeAutoMergedCells", type: "boolean", default: false },
      //         { propName: "includeCalcModelCache", type: "boolean", default: false },
      //         { propName: "includeUnusedNames", type: "boolean", default: true },
      //         { propName: "includeEmptyRegionCells", type: "boolean", default: true },
      //     ],

    };
  },
  methods: {
            excelDownload() {
              this.saveOptions.sheetIndex  = this.excelProp.sheetIndex;
              this.saveOptions.row         = this.excelProp.row;
              this.saveOptions.column      = this.excelProp.column;
              this.saveOptions.rowCount    = this.excelProp.rowCount;
              this.saveOptions.columnCount = this.excelProp.columnCount;
                //var fileType = 'xlsx';//this.saveFileType;
              var fileName = this.excelName + '.xlsx';
               // var options = this.getOptions();
         // console.log('options',options);
                // if (fileType === 'sjs') {
                //     this.spread.save(function(blob) { saveAs(blob, fileName); }, function() {}, options);
                // } else {
              this.saveOptions.fileType = GC.Spread.Sheets.FileType.excel;//'xlsx';//this.mapExportFileType(fileType);
              console.log('---------------------',fileName,this.spread);
              console.log(this.spread,typeof this.spread);
              this.spread.export(
                function(blob) {
                  console.log('111',blob, fileName);
                  saveAs(blob, fileName);
                  console.log('222');
                }, 
                function() {}, 
                this.saveOptions
              );
                // }
            },
            getOptions () {
              let optionsConfig, optionsValue;
              // if (mode === 'open') {
              //     optionsConfig = this.openOptionsConfig[this.openFileType];
              //     optionsValue = this.openOptions;
              // } else {
              optionsConfig = this.saveOptionsConfig;
              optionsValue = this.saveOptions;
              // }
  
              let options = {};
              optionsConfig.forEach((prop) => {
                  let v = optionsValue[prop.propName];
                  if (prop.type === 'number') {
                      v = +v;
                  }
                  options[prop.propName] = v;
              });
  
              return options;
            },
            // getFileType(file) {
            //     if (!file) {
            //         return;
            //     }
    
            //     var fileName = file.name;
            //     var extensionName = fileName.substring(fileName.lastIndexOf(".") + 1);
    
            //     if (extensionName === 'sjs') {
            //         return 'sjs';
            //     } else if (extensionName === 'xlsx' || extensionName === 'xlsm') {
            //         return 'xlsx';
            //     } else if (extensionName === 'ssjson' || extensionName === 'json') {
            //         return 'ssjson';
            //     } else if (extensionName === 'csv') {
            //         return 'csv';
            //     }
            // },
            // mapExportFileType (fileType) {
            //     if (fileType === 'ssjson') {
            //         return GC.Spread.Sheets.FileType.ssjson;
            //     } else if (fileType === 'csv') {
            //         return GC.Spread.Sheets.FileType.csv;
            //     }
            //     return GC.Spread.Sheets.FileType.excel;
            // },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/common/control/excel/SpreadJsExcelDownload.vue